import { render, staticRenderFns } from "./selectGoods.vue?vue&type=template&id=5845e3a2&"
import script from "./selectGoods.vue?vue&type=script&lang=js&"
export * from "./selectGoods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports